export default Object.freeze({
  /**
   * Error is undetermined
   */
  unknown: 'UnknownError',
  /**
   * An internal api error.
   */
  api: 'ApiError',
  /**
   *  One or more of the input parameters failed validation.
   */
  validation: 'ValidationError',
  /**
   * An authorisation or authentication error.
   */
  security: 'SecurityError',
  /**
   * Resource not found
   */
  notFoundError: 'NotFoundError',
})
